import { Box } from '@chakra-ui/layout'
import { } from 'containers'
import { connectNetwork } from 'lib/NetworkProvider'
import { routes, route_from } from 'lib/routes'
import View from 'lib/View'
import moment from 'momentconfig'
import React, { Component } from 'react'

import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Button, Icon, Input, Table } from 'semantic-ui-react'
import { Confirmation, ImageDefault } from '../components'
import { floatTimeToString, timeString } from '../lib/util'

const { app, families, familyEdit } = routes

class Family extends Component {
    constructor(props) {
        super(props)

        let { onCostChange, family } = props

        this.state = {
            deleting: false,
            ...family,
            familyMinutes: family ? parseFloat(family.familyMinutes) : 0,
        }

        if (onCostChange && family) {
            onCostChange(this.totalCost(), family.id)
        }
    }

    totalCost() {
        let { familyHourlyRate, familyHours, familyMinutes } = this.state
        let total = (familyHours + familyMinutes / 60) * parseFloat(familyHourlyRate)
        if (isNaN(total)) {
            total = 0
        }
        return total
    }

    componentDidMount() {
        let { family, id, network } = this.props

        if ((!family || !family.id) && id) {
            network.getFamily(id)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { onCostChange, getFamily, login } = this.props
        let { id, familyHourlyRate } = this.state
        if (familyHourlyRate !== prevState.familyHourlyRate) {
            if (onCostChange) {
                onCostChange(this.totalCost(), id)
            }
        }

        // console.log('Family getFamily fetching', getFamily.fetching)
        if (getFamily && getFamily.fetching !== prevProps.getFamily.fetching && !getFamily.fetching) {
            // console.log('Done calling getFamily')
            if (getFamily.status.success) {
                // console.log(getFamily.data)
                let family = getFamily.data.data

                this.setState({ ...family })
                // console.log('Calling Get family', login, family)
                /*
				if (login && login.data.user && login.data.user.companies) {
					let company = login.data.user.companies[organization.data[0]]
					// console.log('Calling getFromIdFiltering', company, jobId)
					network.getFromIdFiltering(company, jobId, [
						{
							key: 'timestamp',
							symbol: '>',
							value: moment().subtract(4, 'hours').format('YYYY-MM-DD HH:mm:ss')
						}
					])
				}*/
                return
            } else {
                // console.log('calling No family found with this id')
            }
        }
    }

    renderBalanceFooter() {
        let { hourtotal, total } = this.props

        let averageHourlyCost = Math.round((total / hourtotal) * 100) / 100
        if (isNaN(averageHourlyCost)) {
            averageHourlyCost = '--'
        }

        return (
            <Table.Row>
                <Table.Cell width="5">Prezzo orario medio: {averageHourlyCost}€/h</Table.Cell>
                <Table.Cell style={{ textAlign: 'right' }} width="4">
                    Totale Ore:
                </Table.Cell>
                <Table.Cell width="4">{floatTimeToString(hourtotal)}</Table.Cell>
                <Table.Cell width="1">Totale:</Table.Cell>
                <Table.Cell width="2">{total}€</Table.Cell>
            </Table.Row>
        )
    }

    renderBalanceHeader() {
        return (
            <Table.Header fullWidth>
                <Table.Row>
                    <Table.HeaderCell width="5">Nome Macchina</Table.HeaderCell>
                    <Table.HeaderCell width="4">Prezzo €/h</Table.HeaderCell>
                    <Table.HeaderCell width="4">Ore di lavoro</Table.HeaderCell>
                    <Table.HeaderCell width="1" />
                    <Table.HeaderCell width="2">Totale</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
        )
    }

    renderForBalance() {
        let { name, familyHourlyRate, familyHours, familyMinutes } = this.state
        return (
            <Table.Row>
                <Table.Cell>{name}</Table.Cell>
                <Table.Cell>
                    <span className="no-print">
                        <Input
                            type="number"
                            step="0.01"
                            value={familyHourlyRate}
                            onChange={(e, data) => {
                                let value = data.value
                                if (value < 0) value = 0
                                this.setState({
                                    familyHourlyRate: value,
                                })
                            }}
                        />
                        €/h
                    </span>
                    <span className="only-print">{familyHourlyRate}€/h</span>
                </Table.Cell>
                <Table.Cell>{timeString(familyHours, familyMinutes)}</Table.Cell>
                <Table.Cell>=</Table.Cell>
                <Table.Cell>{this.totalCost()}€</Table.Cell>
            </Table.Row>
        )
    }

    renderTableFooter() {
        let { isBalance } = this.props
        if (isBalance) return this.renderBalanceFooter()
        else return null
    }

    renderTableHeader() {
        let { hideFamily, hideFamilyHours, isBalance } = this.props
        if (isBalance) {
            return this.renderBalanceHeader()
        } else {
            return (
                <Table.Header fullWidth>
                    <Table.Row>
                        {!hideFamily && <Table.HeaderCell>Nome Macchina</Table.HeaderCell>}
                        {!hideFamilyHours && <Table.HeaderCell>Ore di lavoro</Table.HeaderCell>}
                    </Table.Row>
                </Table.Header>
            )
        }
    }

    renderForTable() {
        let { hideFamily, hideFamilyHours, isBalance } = this.props
        let { name, familyHours, familyMinutes } = this.state

        if (isBalance) {
            return this.renderForBalance()
        } else {
            return (
                <Table.Row>
                    {!hideFamily && <Table.Cell>{name}</Table.Cell>}
                    {!hideFamilyHours && <Table.Cell>{timeString(familyHours, familyMinutes)}</Table.Cell>}
                </Table.Row>
            )
        }
    }

    openRemoveDialog() {
        this.setState({ deleting: true })
    }

    remove() {
        let { network, family } = this.props

        network.deleteFamily(family)

        this.setState({ deleting: false })
    }

    render() {
        let { login, type, family, onClick, selected, noActions, traversable } = this.props
        let { deleting, familyId: id, familyName, familyDescription, familyImages } = this.state

        let extraprops = {
            fluid: type === 'full' ? true : false,
        }

        if (onClick) {
            extraprops.onClick = () => {
                onClick(family)
            }
        }
        let user = null
        if (login && login.authenticated) {
            user = login.data.user
        }

        switch (type) {
            case 'footer':
                return this.renderTableFooter()
            case 'header':
                return this.renderTableHeader()
            case 'table':
                return this.renderForTable()
            default:
                return (
                    <View fullw column between>
                        <Box borderWidth="1px" borderRadius="lg"
                    p="4" overflow="hidden" className={selected ? 'rowSelected' : ''} style={styles.familyCard} {...extraprops} >
                            <Confirmation
                                message="Vuoi davvero eliminare questa famiglia?"
                                showModal={deleting}
                                onConfirm={() => {
                                    this.remove()
                                }}
                                onCancel={() => {
                                    this.setState({ deleting: false })
                                }}
                            />
                            <Box textStyle="content" style={styles.familyContent}>
                                <View fullw row>
                                    {familyImages && familyImages.length > 0 && (
                                        <div style={styles.imageContainer}>
                                            <ImageDefault fromRoot src={familyImages[0].picturePath} ui={false} style={styles.familyImage} />
                                        </div>
                                    )}
                                    {!familyImages ||
                                        (familyImages.length === 0 && (
                                            <div style={styles.imageContainer}>
                                                <ImageDefault fromRoot src={null} ui={false} style={styles.familyImage} />
                                            </div>
                                        ))}
                                    <View fullw column>
                                        <span style={styles.header}>{familyName}</span>
                                        <Box textStyle="description">{familyDescription}</Box>
                                    </View>
                                </View>
                            </Box>
                            {!noActions && (
                                <Box textStyle="content" extra>
                                    {user && !!user.manage_family && (
                                        <Button
                                            color="blue"
                                            onClick={() => {
                                                this.props.history.push(route_from(app, families, familyEdit, `${id}`))
                                            }}
                                        >
                                            <Icon name="edit" />
                                            Modifica
                                        </Button>
                                    )}

                                    {user && !!user.manage_family && (
                                        <Button
                                            color="red"
                                            onClick={() => {
                                                this.openRemoveDialog()
                                            }}
                                        >
                                            <Icon name="delete" />
                                            Elimina
                                        </Button>
                                    )}
                                </Box>
                            )}
                            {traversable && (
                                <Box textStyle="content" extra>
                                    <Button
                                        color="yellow"
                                        onClick={() => {
                                            this.props.onTraverse(family)
                                        }}
                                    >
                                        <Icon name="folder" />
                                        Apri
                                    </Button>
                                    {user && !!user.manage_family && (
                                        <Button
                                            color="blue"
                                            onClick={() => {
                                                this.props.history.push(route_from(app, families, familyEdit, `${id}`))
                                            }}
                                        >
                                            <Icon name="edit" />
                                            Modifica
                                        </Button>
                                    )}
                                </Box>
                            )}
                        </Box>
                    </View>
                )
        }
    }
}

const styles = {
    header: {
        fontSize: '32pt',
        lineHeight: 'normal',
    },
    imageContainer: {
        minWidth: 200,
        minHeight: 150,
        marginRight: 28,
    },
    familyImage: {
        width: 200,
        height: 150,
        objectFit: 'contain',
    },
    familyContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    familyCard: {
        marginTop: 8,
        marginBottom: 8,
    },
}

const mapStateToProps = (state) => {
    let { login, getFamily } = state
    let rcode = null
    if (login && login.data && login.data.user) rcode = login.data.user.rcode

    return { role: rcode, getFamily, login }
}

export default withRouter(connect(mapStateToProps)(connectNetwork(Family)))
